export const getOrCreateBubble = (messageGroup) => {
  let bubble = messageGroup.querySelector('.aws-chatkit-bubble');
  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'aws-chatkit-bubble';
    messageGroup.appendChild(bubble);
  }
  return bubble;
};
